import { ActionIcon, Text } from "@mantine/core";
import { ArrowUp } from "lucide-react";

import { ErrorAlert } from "../../../platform/ErrorAlert";
import { Price } from "../../../ui/Price";
import { UsageNotes } from "../../../ui/UsageNotes";
import type { Composer } from "./use-composer";

/** The price and the start arrow, at the footer's right in both composers. */
export function PriceAndStart({ c }: { c: Composer }) {
  return (
    <>
      {/* Live's yellow pin beside the price, where the job's mode has notes. */}
      <UsageNotes notes={c.notes} />
      <Price priced={c.priced} pending={c.pricing} />
      <ActionIcon
        variant="filled"
        size="lg"
        radius="100%"
        aria-label="Start"
        // Priced before a prompt is written, it still starts only with one.
        disabled={
          !c.startMissing && (!c.parsed.success || c.priced === undefined || c.refusal !== null)
        }
        loading={c.start.isPending}
        onClick={c.startJob}
      >
        <ArrowUp size={20} />
      </ActionIcon>
    </>
  );
}

/** A failed quote or start, said where it happened. */
export function ComposerErrors({ c }: { c: Composer }) {
  return (
    <>
      {c.startProblem === null ? null : (
        <Text size="sm" c="var(--cai-color-text-danger)" role="alert">
          {c.startProblem}
        </Text>
      )}
      {c.refusal === null ? null : (
        <Text size="sm" c="var(--cai-color-text-danger)" role="alert">
          {c.refusal}
        </Text>
      )}
      {c.notice === null ? null : (
        <Text component="output" size="sm" c="var(--cai-color-text-muted)">
          {c.notice}
        </Text>
      )}
      {c.quoteFailed ? <ErrorAlert error={c.quote.error} /> : null}
      {c.start.isError ? <ErrorAlert error={c.start.error} /> : null}
    </>
  );
}
